/**
 * My ideas: the signed-in person's own active ideas by what the Verdict
 * column shows, how many still wait on research, and the research runs they asked
 * for. The Ideas page has no author filter, so the legend does not link.
 */

import type { Dashboard } from '@/api/types';
import { OUTCOME_SEG } from '@/routes/business-opportunities/MatrixTiles';
import { OUTCOMES, OUTCOME_STYLE } from '@/routes/business-opportunities/ideaUi';
import { formatInt } from '@/ui/format';
import { SplitCard } from '@/ui/SplitCard';

export function MineCard({ data }: { data: Dashboard['mine'] }) {
  const waiting = data.verdict_counts.researching ?? 0;
  return (
    <SplitCard
      label="My ideas"
      figure={data.total}
      noun={data.total === 1 ? 'active idea of mine' : 'active ideas of mine'}
      aside={waiting > 0 ? <span className="usage-card-of">{formatInt(waiting)} in research</span> : undefined}
      parts={
        data.total === 0
          ? []
          : OUTCOMES.map((o) => ({ key: o, label: OUTCOME_STYLE[o].label, count: data.verdict_counts[o] ?? 0, seg: OUTCOME_SEG[o] }))
      }
      note={
        data.total === 0
          ? "You have no active ideas."
          : `${formatInt(data.runs_requested)} research ${data.runs_requested === 1 ? 'run' : 'runs'} requested by you`
      }
    />
  );
}
